import { useState, useEffect } from "react";
import ScrollToTop from "react-scroll-to-top";

const ScrollButton = () => {
  const [buttonStyle, setButtonStyle] = useState({
    width: "3rem",
    height: "3rem", 
    right: "2rem",  
    bottom: "2rem", 
  });

  useEffect(() => {
    const updateButtonStyle = () => {
      // Adjust button size and position based on window width
      if (window.innerWidth <= 430) {
        setButtonStyle({
          width: "4.5rem", 
          height: "4.5rem",
          right: "1.5rem", 
          bottom: "1.5rem",
        });
      } else if (window.innerWidth <= 768) {  
        setButtonStyle({
          width: "5rem", 
          height: "5rem",
          right: "2rem",
          bottom: "5rem",
        });
      } else {
        setButtonStyle({
          width: "6rem", 
          height: "6rem",
          right: "5rem", 
          bottom: "3rem",
        });
      }
    };

    window.addEventListener("resize", updateButtonStyle);
    updateButtonStyle(); // Run on mount

    return () => window.removeEventListener("resize", updateButtonStyle);
  }, []);

  return (
    <ScrollToTop
      smooth
      color="#FFF"
      style={{
        backgroundColor: "rgba(128, 128, 128, 0.6)",
        borderRadius: "50%",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
        ...buttonStyle, 
      }}
    />
  );
};

export default ScrollButton;
